import React from 'react';
import styles from './Spinner.module.css';

const Spinner = ({ size = 'medium', message = '' }) => {
    const sizeClass = styles[size] || styles.medium;

    return (
        <div className={styles.spinnerContainer}>
            <div className={`${styles.spinner} ${sizeClass}`}>
                <div className={styles.circle}></div>
                <div className={styles.circle}></div>
                <div className={styles.circle}></div>
            </div>
            {message && <p className={styles.message}>{message}</p>}
        </div>
    );
};

export default Spinner;
